import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { ConfirmButton } from "./PatientConsentManagerShared.styles";
import { FastenButtonContainer } from "./FastenButtonContainer";
export const DocumentRetrievalContinueWithoutSharing = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const [isLoading, setIsLoading] = React.useState(false);
    const handleConfirmContinue = async () => {
        if (isLoading)
            return;
        setIsLoading(true);
        await props.onConfirmContinue();
    };
    let title;
    if (props.isIAS) {
        title = t("Continue without accessing records?");
    }
    else if (props.isAIFlow) {
        title = t("Continue without connecting records?");
    }
    else {
        title = t("Continue without sharing records?");
    }
    let supportingText;
    if (props.isIAS) {
        supportingText = t("By continuing without accessing records, you won’t get your HealthEx Unified Record.");
    }
    else if (props.isAIFlow) {
        supportingText = t("By continuing without connecting records, you won’t be connected with {{ aiToolName }}.", {
            aiToolName: props.aiToolName,
        });
    }
    else {
        supportingText = t("By continuing without sharing records, you won't share any records with {{ orgName }} for this request.", {
            orgName: props.organizationName,
        });
    }
    return (_jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: title, supportingText: supportingText, buttons: _jsxs(_Fragment, { children: [_jsx(ConfirmButton, { onClick: handleConfirmContinue, loading: isLoading, disabled: isLoading, children: t("Yes, continue") }), _jsx(FastenButtonContainer, { publicId: props.fastenPublicId, patientId: props.fastenPatientId, isStatic: props.isStatic, onAddAnotherClicked: props.onAddAnotherClicked, heapId: "continue-without-sharing-add-provider-button", buttonText: t("Add a provider") })] }) }));
});
addDisplayName(DocumentRetrievalContinueWithoutSharing, "DocumentRetrievalContinueWithoutSharing");
